import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';
import RichTextContent from 'components/common/contentful/rich_text_content';
import SpecificationAccordionRow from './specification_accordion';

// This component is a slight misnomer since it is used for all
// non-featured products, some of which are actually first party products.

// The language-agnostic key for the 'Included' specification section
export const INCLUDED_SECTION_KEY = 'included_items';

const ThreePPContent = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { currentProduct, ...rootProps } = props;

  const renderPartsIncluded = () => (
    <SpecificationAccordionRow
      title={t('productPage.partsIncluded')}
      key={t('productPage.partsIncluded')}
    >
      {currentProduct.parts_included.map(({ name }) => (
        <p key={name}>{name}</p>
      ))}
    </SpecificationAccordionRow>
  );

  const renderSpecs = () => {
    if (!currentProduct) return null;

    const { pos_kit, specifications } = currentProduct;
    // check for the 'Included' specification section
    const hasIncludedSpec = specifications?.some(
      ({ key }) => key === INCLUDED_SECTION_KEY,
    );

    return (
      <div data-testid="spec-rows">
        {pos_kit && !hasIncludedSpec && renderPartsIncluded()}
        {specifications?.map(({ title, content }) => (
          <SpecificationAccordionRow
            data-testid={`spec-row-${title}`}
            title={title}
            content={content}
            key={title}
          />
        ))}
      </div>
    );
  };

  return (
    <Box {...rootProps}>
      <RichTextContent
        data-testid="3pp-description"
        content={currentProduct.description}
      />
      {currentProduct.disclaimer && (
        <RichTextContent
          data-testid="3pp-disclaimer"
          content={currentProduct.disclaimer}
          color={theme.color.gray['55']}
          className="paragraph-20"
        />
      )}
      {renderSpecs()}
    </Box>
  );
};

export default ThreePPContent;
